// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"b7a8db45","117":"2fcd5267","503":"3053ac3d","789":"73a42186"}[chunkId] + ".chunk.css";
};